/* eslint-disable no-undef */
import axios from '../utils/axios'

/**
 * @description 获取组织代码
 * @author 80348277
 * @date 2021-09-10
 * @export
 * @param {AuthParams} params
 * @returns {*}
 */
export async function getOrgCode(params: Params) {
  return axios.get<Array<string>>('/api/isc/purchase/getOrgCode', { params })
}

export async function postOrgCode(params: Params) {
  return axios.post<TrendData>('/api/isc/purchase/getOrgCode', params)
}

export async function userLogout(params: Params) {
  return axios.get('/v2/rbac/authority/logout', { params })
}

export async function userLogin(params: Params) {
  return axios.get('/v2/rbac/authority/login', { params })
}

/**
 * @description
 * @author 80348277
 * @date 2022-01-12
 * @export
 * @param {*} params
 * @returns {*}
 */
export async function getTest(params) {
  return axios.get('/api/get', { params })
}

export async function getToken() {
  return axios.get('/v2/rbac/authority/getToken')
}
export async function getAccountAuthority() {
  return axios.get('/v2/rbac/accountAuthority')
}

// 清空token
export async function cleanTokenAPI() {
  return axios.get('/v2/rbac/authority/cleanToken')
}

/**
 * @description  获取动态参数信息
 * @param params
 * @returns
 */
export async function getTemplateDynamicInfo() {
  return axios.get(`/v2/feedback/api/template/dynamicInfo`)
}

/**
 * @description  公告管理-获取最新的公告
 * @param params
 * id 	id
 * @returns
 */
export async function getLastOneAnn(params) {
  return axios.get(`/v2/feedback/api/announcement/lastOne`, { params })
}
